import { takeLatest, put, fork } from "redux-saga/effects";
import { AxiosResponse } from "axios";
import { Notifications } from "../../Apis/AuthApiServices";
import {
  loadingNotifications,
  setNotifications,
} from "../Slice/NotificationSlice";

function* onLoadNotificationAsync({ payload }: any) {
  const params = new URLSearchParams();
  let doctorId: any = localStorage.getItem("doctorId");
  params.append("doctorId", doctorId);
  params.append("isNewItems", payload.isNewItems);
  try {
    const result: AxiosResponse = yield Notifications(params);
    if (result?.data?.digitalRxStatusCode === 200) {
      yield put(
        setNotifications({
          AllNotifications: result?.data?.response[0],
          error: false,
          isLoading: false,
        })
      );
    } else {
      yield put(
        setNotifications({
          AllNotifications: [],
          error: true,
          isLoading: false,
          message: result?.data?.digitalRxStatusMessage,
        })
      );
    }
  } catch (error) {
    yield put(
      setNotifications({
        AllNotifications: [],
        error: true,
        isLoading: false,
        message: "Try Again After Some Time!",
      })
    );
  }
}

function* onLoadNotifications() {
  yield takeLatest(loadingNotifications.type, onLoadNotificationAsync);
}

const NotificationSaga = [fork(onLoadNotifications)];

export default NotificationSaga;
